export default function Logo(): React.ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
      <title>Xcode</title>
      <linearGradient
        id="xcode-original-a"
        gradientUnits="userSpaceOnUse"
        x1="63.947"
        y1="114.165"
        x2="63.947"
        y2="13.784"
      >
        <stop offset="0" stopColor="#1578e4" />
        <stop offset="1" stopColor="#00c3f2" />
      </linearGradient>
      <path
        d="M35.7 13.8h56.5c12.1 0 21.9 9.8 21.9 21.9v56.5c0 12.1-9.8 21.9-21.9 21.9H35.7c-12.1 0-21.9-9.8-21.9-21.9V35.7c0-12.1 9.8-21.9 21.9-21.9z"
        fill="url(#xcode-original-a)"
      />
      <path
        fill="#FFF"
        d="M90.5 19.2H37.4c-10.1 0-18.3 8.2-18.3 18.3v53.1c0 10.1 8.2 18.3 18.3 18.3h53.1c10.1 0 18.3-8.2 18.3-18.3V37.4c0-10.1-8.2-18.2-18.3-18.2zm16.8 71.6c0 9.2-7.4 16.6-16.6 16.6H37.2c-9.1 0-16.6-7.4-16.6-16.6V37.2c0-9.2 7.4-16.6 16.6-16.6h53.6c9.1 0 16.6 7.4 16.6 16.6v53.6z"
      />
      <path
        d="M64.1 22.8c-22.6 0-41 18.4-41 41s18.4 41 41 41c22.7 0 41-18.4 41-41s-18.4-41-41-41zm0 81.4c-22.3 0-40.4-18.1-40.4-40.4s18.1-40.4 40.4-40.4c22.3 0 40.4 18.1 40.4 40.4s-18.1 40.4-40.4 40.4z"
        fill="#69c5f3"
      />
      <path
        d="M64.1 31.2c-18.1 0-32.7 14.6-32.7 32.7S46 96.5 64.1 96.5s32.7-14.6 32.7-32.7-14.7-32.6-32.7-32.6zm0 64.6c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.4 32-32 32z"
        fill="#68c5f4"
      />
      <path
        fill="#FFF"
        d="M32.8 71.3h62.4c2.6 0 4.6 2.1 4.6 4.6 0 2.6-2.1 4.6-4.6 4.6H32.8c-2.6 0-4.6-2.1-4.6-4.6-.1-2.5 2-4.6 4.6-4.6z"
      />
      <path
        d="M32.6 72.2h62.6c2 0 3.7 1.6 3.7 3.7v.1c0 2-1.6 3.7-3.7 3.7H32.6c-2 0-3.7-1.6-3.7-3.7v-.2c.1-2 1.7-3.6 3.7-3.6z"
        fill="#0a93e9"
      />
      <path d="M31.1 79.3h65.7l.5-.3H30.6l.5.3z" fill="#1694ea" />
      <path d="M29.6 78.1h68.6l.2-.3h-69l.2.3z" fill="#319dec" />
      <path d="M29 76.2h69.9v-.4H29v.4z" fill="#65b1ee" />
      <path d="M29.7 73.7h68.6l.1.2.1.2h-69l.1-.2.1-.2z" fill="#8ec6f3" />
      <path d="M31.2 72.5h65.6l.3.1.3.2H30.6l.3-.2.3-.1z" fill="#95caf3" />
      <linearGradient
        id="xcode-original-b"
        gradientUnits="userSpaceOnUse"
        x1="94.037"
        y1="79.666"
        x2="94.037"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7" />
        <stop offset="1" stopColor="#dbedfb" />
      </linearGradient>
      <path
        d="M93.4 72.2h-.5s1.7 1.2 1.7 3.9c0 2.5-1.7 3.6-1.7 3.6h.5s1.7-.8 1.7-3.6c0-3-1.7-3.9-1.7-3.9z"
        fill="url(#xcode-original-b)"
      />
      <linearGradient
        id="xcode-original-c"
        gradientUnits="userSpaceOnUse"
        x1="89.042"
        y1="79.666"
        x2="89.042"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7" />
        <stop offset="1" stopColor="#dbedfb" />
      </linearGradient>
      <path
        d="M88.6 72.2h-.5s1.5 1.4 1.5 3.9c0 2.2-1.5 3.6-1.5 3.6h.5s1.5-1.1 1.5-3.6c-.1-2.7-1.5-3.9-1.5-3.9z"
        fill="url(#xcode-original-c)"
      />
      <linearGradient
        id="xcode-original-d"
        gradientUnits="userSpaceOnUse"
        x1="63.947"
        y1="79.666"
        x2="63.947"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7" />
        <stop offset="1" stopColor="#dbedfb" />
      </linearGradient>
      <path d="M63.7 72.2h.5v7.5h-.5v-7.5z" fill="url(#xcode-original-d)" />
      <linearGradient
        id="xcode-original-e"
        gradientUnits="userSpaceOnUse"
        x1="58.952"
        y1="79.666"
        x2="58.952"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7" />
        <stop offset="1" stopColor="#dbedfb" />
      </linearGradient>
      <path
        d="M58.8 72.2h.5s-.2 1.9-.2 3.9c0 1.8.2 3.6.2 3.6h-.5s-.2-1.8-.2-3.6c0-2 .2-3.9.2-3.9z"
        fill="url(#xcode-original-e)"
      />
      <linearGradient
        id="xcode-original-f"
        gradientUnits="userSpaceOnUse"
        x1="53.958"
        y1="79.666"
        x2="53.958"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7" />
        <stop offset="1" stopColor="#dbedfb" />
      </linearGradient>
      <path
        d="M54 72.2h.5s-.5 1.9-.5 3.9c0 1.8.5 3.6.5 3.6H54s-.5-1.8-.5-3.6c0-2 .5-3.9.5-3.9z"
        fill="url(#xcode-original-f)"
      />
      <linearGradient
        id="xcode-original-g"
        gradientUnits="userSpaceOnUse"
        x1="48.963"
        y1="79.666"
        x2="48.963"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7" />
        <stop offset="1" stopColor="#dbedfb" />
      </linearGradient>
      <path
        d="M49.1 72.2h.5s-.7 1.9-.7 3.9c0 1.8.7 3.6.7 3.6h-.5s-.7-1.8-.7-3.6c0-2 .7-3.9.7-3.9z"
        fill="url(#xcode-original-g)"
      />
      <linearGradient
        id="xcode-original-h"
        gradientUnits="userSpaceOnUse"
        x1="43.968"
        y1="79.666"
        x2="43.968"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7" />
        <stop offset="1" stopColor="#dbedfb" />
      </linearGradient>
      <path
        d="M44.2 72.2h.5s-1 1.6-1 3.9c0 2 1 3.6 1 3.6h-.5s-1-1.6-1-3.6c0-2.3 1-3.9 1-3.9z"
        fill="url(#xcode-original-h)"
      />
      <linearGradient
        id="xcode-original-i"
        gradientUnits="userSpaceOnUse"
        x1="38.852"
        y1="79.666"
        x2="38.852"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7" />
        <stop offset="1" stopColor="#dbedfb" />
      </linearGradient>
      <path
        d="M39.3 72.2h.5s-1.5 1.4-1.5 3.9c0 2.2 1.5 3.6 1.5 3.6h-.5s-1.5-1.1-1.5-3.6c.1-2.7 1.5-3.9 1.5-3.9z"
        fill="url(#xcode-original-i)"
      />
      <linearGradient
        id="xcode-original-j"
        gradientUnits="userSpaceOnUse"
        x1="33.857"
        y1="79.666"
        x2="33.857"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7" />
        <stop offset="1" stopColor="#dbedfb" />
      </linearGradient>
      <path
        d="M34.5 72.2h.5s-1.7 1.2-1.7 3.9c0 2.5 1.7 3.6 1.7 3.6h-.5s-1.7-.8-1.7-3.6c0-3 1.7-3.9 1.7-3.9z"
        fill="url(#xcode-original-j)"
      />
      <path
        fill="#FFF"
        d="M62 34.1l31.2 54c1.3 2.2.5 5-1.7 6.3-2.2 1.3-5 .5-6.3-1.7L54 38.7c-1.3-2.2-.5-5 1.7-6.3 2.2-1.3 5-.5 6.3 1.7z"
      />
      <linearGradient id="xcode-original-k" gradientUnits="userSpaceOnUse" x1="73.58" y1="94.25" x2="73.58" y2="32.642">
        <stop offset="0" stopColor="#1285e7" />
        <stop offset="1" stopColor="#00b5ef" />
      </linearGradient>
      <path
        d="M61.2 34.5l31.3 54.2c1 1.7.4 4-1.3 5l-.2.1c-1.7 1-4 .4-5-1.3L54.7 38.2c-1-1.7-.4-4 1.3-5l.1-.1c1.8-1 4.1-.4 5.1 1.4z"
        fill="url(#xcode-original-k)"
      />
      <linearGradient
        id="xcode-original-l"
        gradientUnits="userSpaceOnUse"
        x1="87.464"
        y1="93.978"
        x2="54.081"
        y2="36.156"
      >
        <stop offset="0" stopColor="#2b90e7" />
        <stop offset="1" stopColor="#00b6ef" />
      </linearGradient>
      <path d="M54.2 36.7L87 93.6l.2.1.2.1.2.1-33.4-57.8v.6z" fill="url(#xcode-original-l)" />
      <linearGradient
        id="xcode-original-m"
        gradientUnits="userSpaceOnUse"
        x1="89.073"
        y1="94.327"
        x2="54.583"
        y2="34.589"
      >
        <stop offset="0" stopColor="#3795ea" />
        <stop offset="1" stopColor="#49c4f2" />
      </linearGradient>
      <path d="M54.5 34.8l34.3 59.4h.4L54.7 34.5l-.1.2-.1.1z" fill="url(#xcode-original-m)" />
      <linearGradient
        id="xcode-original-n"
        gradientUnits="userSpaceOnUse"
        x1="91.026"
        y1="93.735"
        x2="56.072"
        y2="33.193"
      >
        <stop offset="0" stopColor="#3696ea" />
        <stop offset="1" stopColor="#90d9f6" />
      </linearGradient>
      <path d="M55.9 33.3l35 60.5.3-.2-35-60.5-.3.2z" fill="url(#xcode-original-n)" />
      <linearGradient
        id="xcode-original-o"
        gradientUnits="userSpaceOnUse"
        x1="92.582"
        y1="92.332"
        x2="58.065"
        y2="32.547"
      >
        <stop offset="0" stopColor="#3097ea" />
        <stop offset="1" stopColor="#b5e5f9" />
      </linearGradient>
      <path d="M58.4 32.7L92.6 92l-.1.2-.1.2-34.5-59.8h.2l.3.1z" fill="url(#xcode-original-o)" />
      <linearGradient
        id="xcode-original-p"
        gradientUnits="userSpaceOnUse"
        x1="93.083"
        y1="90.686"
        x2="59.741"
        y2="32.936"
      >
        <stop offset="0" stopColor="#3a98ea" />
        <stop offset="1" stopColor="#bce7fa" />
      </linearGradient>
      <path d="M60.2 33.3L93 90.1v.6L59.6 33l.2.1.2.1.2.1z" fill="url(#xcode-original-p)" />
      <path
        fill="#3c98ea"
        d="M91.5 86.9l-.2-.4s-.2 2-2.4 3.4c-2.1 1.3-4 .4-4 .4l.2.4s1.6 1.1 4-.4c2.4-1.4 2.4-3.4 2.4-3.4zM89 82.7l-.2-.4s-.5 2-2.6 3.2c-1.9 1.2-3.8.6-3.8.6l.2.4s1.7.7 3.9-.6c2.2-1.3 2.5-3.2 2.5-3.2z"
      />
      <path
        d="M86.6 78.5l-.2-.4s-.9 1.7-2.8 2.8c-1.7 1-3.6 1-3.6 1l.2.4s1.8 0 3.6-1c1.9-1.1 2.8-2.8 2.8-2.8z"
        fill="#4ca4ed"
      />
      <path
        d="M84.2 74.3l-.2-.4s-1.3 1.7-3 2.6c-1.6.9-3.5 1.2-3.5 1.2l.2.4s1.9-.3 3.5-1.2c1.6-.9 3-2.6 3-2.6z"
        fill="#4da7ee"
      />
      <linearGradient
        id="xcode-original-q"
        gradientUnits="userSpaceOnUse"
        x1="67.981"
        y1="61.226"
        x2="74.457"
        y2="57.487"
      >
        <stop offset="0" stopColor="#00a4ec" />
        <stop offset="1" stopColor="#b9dff6" />
      </linearGradient>
      <path
        d="M74.3 57.3l.2.4s-1.7.8-3.4 1.7c-1.6.9-3 2.1-3 2.1l-.2-.4s1.5-1.2 3-2.1c1.7-.9 3.4-1.7 3.4-1.7z"
        fill="url(#xcode-original-q)"
      />
      <linearGradient
        id="xcode-original-r"
        gradientUnits="userSpaceOnUse"
        x1="65.487"
        y1="56.906"
        x2="71.962"
        y2="53.167"
      >
        <stop offset="0" stopColor="#00a4ec" />
        <stop offset="1" stopColor="#b9dff6" />
      </linearGradient>
      <path
        d="M71.9 53.1l.2.4s-1.9.6-3.5 1.6c-1.6.9-2.9 2.3-2.9 2.3l-.2-.4s1.3-1.4 2.9-2.3c1.6-1.1 3.5-1.6 3.5-1.6z"
        fill="url(#xcode-original-r)"
      />
      <path d="M67.4 49.8c1.3-.4 2.3-.6 2.3-.6l-.2-.4s-.9.1-1.9.5c-.6.2-.7.7-.2.5z" fill="#9dd4f7" />
      <linearGradient
        id="xcode-original-s"
        gradientUnits="userSpaceOnUse"
        x1="57.93"
        y1="43.819"
        x2="64.364"
        y2="40.105"
      >
        <stop offset="0" stopColor="#00b4ef" />
        <stop offset="1" stopColor="#c3e9fa" />
      </linearGradient>
      <path
        d="M64.6 40.5l.2.4s-1.9-.5-4.1.7c-1.9 1.2-2.3 3.1-2.3 3.1l-.2-.4s.2-1.7 2.3-3c2.2-1.4 4.1-.8 4.1-.8z"
        fill="url(#xcode-original-s)"
      />
      <linearGradient
        id="xcode-original-t"
        gradientUnits="userSpaceOnUse"
        x1="55.424"
        y1="39.477"
        x2="61.9"
        y2="35.738"
      >
        <stop offset="0" stopColor="#00b4ef" />
        <stop offset="1" stopColor="#c3e9fa" />
      </linearGradient>
      <path
        d="M62.2 36.2l.3.4s-2-.8-4.3.5C56 38.5 56 40.4 56 40.4l-.3-.4s-.2-1.7 2.2-3.2c2.5-1.5 4.3-.6 4.3-.6z"
        fill="url(#xcode-original-t)"
      />
      <path
        fill="#FFF"
        d="M55.5 71.3c8.7-15 18.7-32.4 18.7-32.4 1.3-2.2.5-5-1.7-6.3-2.2-1.3-5-.5-6.3 1.7 0 0-12.2 21.2-21.4 37h10.7zm-5.4 9.2C45.9 87.7 43 92.9 43 92.9c-1.3 2.2-4.1 3-6.3 1.7s-3-4.1-1.7-6.3c0 0 1.7-3.1 4.4-7.7 3.4-.1 9.6-.1 10.7-.1z"
      />
      <linearGradient
        id="xcode-original-u"
        gradientUnits="userSpaceOnUse"
        x1="54.566"
        y1="94.401"
        x2="54.566"
        y2="32.794"
      >
        <stop offset="0" stopColor="#1285e7" />
        <stop offset="1" stopColor="#00b5ef" />
      </linearGradient>
      <path
        d="M54.4 71.3c8.8-15.2 19-32.9 19-32.9 1-1.7.4-4-1.3-5l-.1-.1c-1.7-1-4-.4-5 1.3 0 0-12 20.8-21.2 36.7h8.6zm-5.3 9.2c-4 7-6.9 12-6.9 12-1 1.7-3.2 2.3-5 1.3H37c-1.7-1-2.3-3.2-1.3-5 0 0 1.9-3.3 4.8-8.3h8.6z"
        fill="url(#xcode-original-u)"
      />
      <linearGradient
        id="xcode-original-v"
        gradientUnits="userSpaceOnUse"
        x1="40.681"
        y1="94.131"
        x2="74.064"
        y2="36.311"
      >
        <stop offset="0" stopColor="#3194e9" />
        <stop offset="1" stopColor="#71cff4" />
      </linearGradient>
      <path
        d="M54.1 71.3L74 36.9v-.6s-11 19.1-20.2 35h.3zm-5.4 9.2l-7.6 13.2-.3.2-.3.1s3.4-5.9 7.8-13.5h.4z"
        fill="url(#xcode-original-v)"
      />
      <linearGradient
        id="xcode-original-w"
        gradientUnits="userSpaceOnUse"
        x1="39.063"
        y1="94.482"
        x2="73.557"
        y2="34.736"
      >
        <stop offset="0" stopColor="#5aa6ec" />
        <stop offset="1" stopColor="#a2def8" />
      </linearGradient>
      <path
        d="M52.6 71.3l21-36.3-.1-.2-.1-.2S61.9 54.5 52.3 71.2l.3.1zm-5.3 9.2l-8 13.8h-.4s3.4-5.9 8-13.9c.2.1.4.1.4.1z"
        fill="url(#xcode-original-w)"
      />
      <linearGradient
        id="xcode-original-x"
        gradientUnits="userSpaceOnUse"
        x1="37.118"
        y1="93.885"
        x2="72.072"
        y2="33.343"
      >
        <stop offset="0" stopColor="#66abee" />
        <stop offset="1" stopColor="#bee8fa" />
      </linearGradient>
      <path
        d="M50.4 71.3c9.9-17.1 21.8-37.8 21.8-37.8l-.3-.2-22 38h.5zM45 80.6C40.6 88.3 37.3 94 37.3 94l-.3-.2s3.2-5.6 7.6-13.2c.2-.1.1-.1.4 0z"
        fill="url(#xcode-original-x)"
      />
      <linearGradient
        id="xcode-original-y"
        gradientUnits="userSpaceOnUse"
        x1="35.568"
        y1="92.482"
        x2="70.085"
        y2="32.697"
      >
        <stop offset="0" stopColor="#7bb6f0" />
        <stop offset="1" stopColor="#b1e3f9" />
      </linearGradient>
      <path
        d="M48 71.3c9.9-17.1 22.2-38.5 22.2-38.5h-.4S57.5 54.1 47.6 71.3h.4zm-5.8 9.2c-4 6.9-6.7 11.6-6.7 11.6l.1.2.1.2s2.9-5 7-12h-.5z"
        fill="url(#xcode-original-y)"
      />
      <linearGradient
        id="xcode-original-z"
        gradientUnits="userSpaceOnUse"
        x1="35.056"
        y1="90.872"
        x2="68.415"
        y2="33.092"
      >
        <stop offset="0" stopColor="#5aa6ec" />
        <stop offset="1" stopColor="#afe3f9" />
      </linearGradient>
      <path
        d="M46.5 71.3l22-38.1-.2.1-.2.1-.1.1S55.8 54.6 46.2 71.3h.3zm-5.3 9.2c-3.5 6.1-6 10.4-6 10.4v-.8s2.2-3.8 5.6-9.7c.2.1.2.1.4.1z"
        fill="url(#xcode-original-z)"
      />
      <linearGradient
        id="xcode-original-A"
        gradientUnits="userSpaceOnUse"
        x1="66.362"
        y1="35.689"
        x2="72.838"
        y2="39.428"
      >
        <stop offset="0" stopColor="#c1e7fa" />
        <stop offset="1" stopColor="#89d4f5" />
      </linearGradient>
      <path
        d="M66 36.2l-.2.4s1.8-.9 4.2.4c2.2 1.2 2.3 3.3 2.3 3.3l.2-.4s.2-1.9-2.3-3.3-4.2-.4-4.2-.4z"
        fill="url(#xcode-original-A)"
      />
      <linearGradient
        id="xcode-original-B"
        gradientUnits="userSpaceOnUse"
        x1="63.856"
        y1="40.03"
        x2="70.332"
        y2="43.768"
      >
        <stop offset="0" stopColor="#c1e7fa" />
        <stop offset="1" stopColor="#89d4f5" />
      </linearGradient>
      <path
        d="M63.6 40.5l-.2.4s2-.6 4.1.6c2 1.1 2.4 3 2.4 3l.2-.4s-.2-1.8-2.4-3c-2.3-1.3-4.1-.6-4.1-.6z"
        fill="url(#xcode-original-B)"
      />
      <linearGradient
        id="xcode-original-C"
        gradientUnits="userSpaceOnUse"
        x1="61.273"
        y1="44.505"
        x2="67.748"
        y2="48.243"
      >
        <stop offset="0" stopColor="#c1e7fa" />
        <stop offset="1" stopColor="#89d4f5" />
      </linearGradient>
      <path
        d="M61.1 44.7l-.2.4s1.8-.1 3.8 1.1c1.8 1 2.7 2.6 2.7 2.6l.2-.4s-.9-1.6-2.7-2.6c-1.9-1.1-3.8-1.1-3.8-1.1z"
        fill="url(#xcode-original-C)"
      />
      <linearGradient
        id="xcode-original-D"
        gradientUnits="userSpaceOnUse"
        x1="58.761"
        y1="48.855"
        x2="65.236"
        y2="52.594"
      >
        <stop offset="0" stopColor="#b0dff8" />
        <stop offset="1" stopColor="#52bdf2" />
      </linearGradient>
      <path
        d="M58.7 49l-.2.4s2 .3 3.7 1.3c1.6.9 2.8 2.4 2.8 2.4l.2-.4s-1.2-1.5-2.8-2.4c-1.7-1-3.7-1.3-3.7-1.3z"
        fill="url(#xcode-original-D)"
      />
      <linearGradient
        id="xcode-original-E"
        gradientUnits="userSpaceOnUse"
        x1="56.25"
        y1="53.204"
        x2="62.727"
        y2="56.943"
      >
        <stop offset="0" stopColor="#b4def8" />
        <stop offset="1" stopColor="#4eb5f0" />
      </linearGradient>
      <path
        d="M56.2 53.2l-.2.4s1.9.5 3.6 1.5c1.6.9 2.9 2.2 2.9 2.2l.2-.4s-1.3-1.3-2.9-2.2c-1.6-.9-3.6-1.5-3.6-1.5z"
        fill="url(#xcode-original-E)"
      />
      <linearGradient
        id="xcode-original-F"
        gradientUnits="userSpaceOnUse"
        x1="53.74"
        y1="57.553"
        x2="60.215"
        y2="61.291"
      >
        <stop offset="0" stopColor="#b4def8" />
        <stop offset="1" stopColor="#4eb5f0" />
      </linearGradient>
      <path
        d="M53.8 57.4l-.3.4s1.8.7 3.5 1.7c1.6.9 3 2 3 2l.2-.4s-1.4-1.1-3-2c-1.6-.9-3.4-1.7-3.4-1.7z"
        fill="url(#xcode-original-F)"
      />
      <linearGradient
        id="xcode-original-G"
        gradientUnits="userSpaceOnUse"
        x1="51.239"
        y1="61.886"
        x2="57.713"
        y2="65.624"
      >
        <stop offset="0" stopColor="#b5ddf8" />
        <stop offset="1" stopColor="#46aeee" />
      </linearGradient>
      <path d="M51.1 62.1l.2-.4 6.5 3.7-.2.4-6.5-3.7z" fill="url(#xcode-original-G)" />
      <linearGradient
        id="xcode-original-H"
        gradientUnits="userSpaceOnUse"
        x1="48.735"
        y1="66.22"
        x2="55.211"
        y2="69.959"
      >
        <stop offset="0" stopColor="#96cef4" />
        <stop offset="1" stopColor="#46aaee" />
      </linearGradient>
      <path
        d="M48.7 66.4l.2-.4s1.6 1.2 3.3 2.1c1.6.9 3.2 1.6 3.2 1.6l-.2.3s-1.7-.7-3.3-1.6c-1.7-.9-3.2-2-3.2-2z"
        fill="url(#xcode-original-H)"
      />
      <path d="M47.1 71.3c-.5-.4-.8-.7-.8-.7l.2-.4s.6.5 1.4 1.1h-.8z" fill="#73b9f1" />
      <linearGradient id="xcode-original-I" gradientUnits="userSpaceOnUse" x1="42.719" y1="80.135" x2="47.681" y2="83">
        <stop offset="0" stopColor="#8fc1f2" />
        <stop offset="1" stopColor="#3193ea" />
      </linearGradient>
      <path
        d="M43.2 80.5c.4.3.8.6 1.3.9 1.8 1 3.6.9 3.6.9l-.2.4s-1.8.1-3.6-.9c-.7-.4-1.3-.9-1.7-1.3h.6z"
        fill="url(#xcode-original-I)"
      />
      <linearGradient
        id="xcode-original-J"
        gradientUnits="userSpaceOnUse"
        x1="38.634"
        y1="83.717"
        x2="45.11"
        y2="87.456"
      >
        <stop offset="0" stopColor="#8fc1f2" />
        <stop offset="1" stopColor="#3193ea" />
      </linearGradient>
      <path
        d="M38.9 83.3l.2-.4s.5 2 2.7 3.2c2 1.1 3.8.5 3.8.5l-.2.4s-1.6.7-3.8-.5c-2.3-1.3-2.7-3.2-2.7-3.2z"
        fill="url(#xcode-original-J)"
      />
      <linearGradient
        id="xcode-original-K"
        gradientUnits="userSpaceOnUse"
        x1="36.124"
        y1="88.063"
        x2="42.599"
        y2="91.802"
      >
        <stop offset="0" stopColor="#8fc1f2" />
        <stop offset="1" stopColor="#3193ea" />
      </linearGradient>
      <path
        d="M36.4 87.6l.2-.4s.2 2.1 2.6 3.4c2.2 1.2 3.9.3 3.9.3l-.3.4s-1.5 1.1-3.9-.3c-2.5-1.4-2.5-3.4-2.5-3.4z"
        fill="url(#xcode-original-K)"
      />
      <linearGradient
        id="xcode-original-L"
        gradientUnits="userSpaceOnUse"
        x1="76.722"
        y1="64.933"
        x2="89.179"
        y2="71.008"
      >
        <stop offset=".001" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <path d="M68.8 114.2l42.8-89.9-10.8-5.1-44.6 93.5s1.4.7 3.2 1.5h9.4z" fill="url(#xcode-original-L)" />
      <radialGradient
        id="xcode-original-M"
        cx="95.237"
        cy="25.132"
        r="16.181"
        fx="79.585"
        fy="25.974"
        gradientTransform="matrix(-.4494 .8933 -1.5457 -.7777 176.886 -40.4)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" />
        <stop offset="1" stopOpacity="0" />
      </radialGradient>
      <path d="M94.1 13.8l20 9.5V52C107.2 48.7 61 26.7 61 26.7s3.2-6.7 6.2-12.9h26.9z" fill="url(#xcode-original-M)" />
      <radialGradient
        id="xcode-original-N"
        cx="51.211"
        cy="114.953"
        r="7.901"
        fx="51.196"
        fy="117.292"
        gradientTransform="matrix(.8979 .4402 -.2506 .5111 34.032 33.662)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".417" stopColor="#0c0c12" />
        <stop offset="1" stopColor="#3d4651" />
      </radialGradient>
      <path
        d="M44.5 110.2c-.3.6-.8 1.3-.7 2.4.1 4.1 6.8 7.9 10.7 7.9 2.7 0 3.6-1.1 4.6-3.1s-13.5-9.6-14.6-7.2z"
        fill="url(#xcode-original-N)"
      />
      <linearGradient
        id="xcode-original-O"
        gradientUnits="userSpaceOnUse"
        x1="84.758"
        y1="39.174"
        x2="94.522"
        y2="44.149"
      >
        <stop offset="0" stopColor="#344351" />
        <stop offset=".1" stopColor="#9697a0" />
        <stop offset=".181" stopColor="#8b8c95" />
        <stop offset=".351" stopColor="#787a83" />
        <stop offset=".47" stopColor="#71747d" />
        <stop offset=".591" stopColor="#777982" />
        <stop offset=".749" stopColor="#87898f" />
        <stop offset=".8" stopColor="#8e8f94" />
        <stop offset=".849" stopColor="#3d3b42" />
        <stop offset=".9" stopColor="#606e84" />
      </linearGradient>
      <path
        d="M90.6 25.1s10.3 2.5 11.1 3.2-1.3 4.7-1.7 5.3c-3.3 4-13.6 26.1-13.6 26.1l-9.5-5.4s8.5-15.8 11.5-21.4c1.9-3.8 2.2-7.8 2.2-7.8z"
        fill="url(#xcode-original-O)"
      />
      <linearGradient
        id="xcode-original-P"
        gradientUnits="userSpaceOnUse"
        x1="117.884"
        y1="29.257"
        x2="106.863"
        y2="14.364"
      >
        <stop offset=".27" stopColor="#262b33" />
        <stop offset=".45" stopColor="#74747e" />
        <stop offset=".54" stopColor="#b0b0bc" />
        <stop offset=".73" stopColor="#74747e" />
      </linearGradient>
      <path
        d="M114.4 19.9c1.8 1.3 4.2 1 6.1.7 1.3-.2-.7 1.7-2.9 6.1s-2.1 4.7-2.4 4.4c-.3-.3-10.2-5.9-9.9-6.4.4-.5 2-11.4 2.8-11.1 2.9.7 3.4 4.2 6.3 6.3z"
        fill="url(#xcode-original-P)"
      />
      <linearGradient
        id="xcode-original-Q"
        gradientUnits="userSpaceOnUse"
        x1="98.542"
        y1="30.424"
        x2="114.815"
        y2="28.322"
      >
        <stop offset=".14" stopColor="#606e84" />
        <stop offset=".4" stopColor="#9899a5" />
        <stop offset=".73" stopColor="#475768" />
        <stop offset=".92" stopColor="#262b33" />
      </linearGradient>
      <path
        d="M99 32.2c.7-1.1 3.9-7.9 9-7.9 2.3 0 6.7 5.8 7.1 6.6.3.7-.7 3.5-1.2 2.2-.6-1.5-3.1-4.7-5.8-4.7s-6.4 3.1-7.3 4.2c-.9 1-2.5.7-1.8-.4z"
        fill="url(#xcode-original-Q)"
      />
      <linearGradient
        id="xcode-original-R"
        gradientUnits="userSpaceOnUse"
        x1="106.128"
        y1="31.808"
        x2="104.549"
        y2="22.854"
      >
        <stop offset="0" stopColor="#101215" stopOpacity=".1" />
        <stop offset=".46" stopColor="#101215" stopOpacity=".7" />
        <stop offset=".7" stopColor="#474951" />
        <stop offset=".91" stopColor="#7b7d88" />
      </linearGradient>
      <path
        d="M98.8 31.8c.5-.8 2.8-4.3 3.9-5.4s3.9-4 6.3-4.4c2.4-.4 4.9 4.5 4.1 5.5-.6.7-1.6-.1-2.8-1.1-1.2-.9-2-2.7-5.8.2-1.3 1-2.6 1.8-5.6 6.1-.8 1.1-.6-.1-.1-.9z"
        fill="url(#xcode-original-R)"
      />
      <linearGradient
        id="xcode-original-S"
        gradientUnits="userSpaceOnUse"
        x1="58.131"
        y1="81.721"
        x2="73.237"
        y2="89.154"
      >
        <stop offset=".115" stopColor="#2c3952" />
        <stop offset=".374" stopColor="#3d414e" />
        <stop offset=".55" stopColor="#474a54" />
        <stop offset=".754" stopColor="#4e5057" />
        <stop offset=".892" stopColor="#323945" />
        <stop offset="1" stopColor="#143052" />
      </linearGradient>
      <path
        d="M86.4 61c.4-.8.9-2-.2-2.9-1.2-.9-6.8-3.9-7.8-4.1-1-.2-1.8 0-2.2.7-.4.7-31.1 53.3-31.7 54.8-.6 1.5-.7 2.6.2 2.9.9.3 11.2 5.2 12.2 6.3 1 1.1 1.5-.1 1.9-.7 1.9-2.4 27.1-56.2 27.6-57z"
        fill="url(#xcode-original-S)"
      />
      <linearGradient
        id="xcode-original-T"
        gradientUnits="userSpaceOnUse"
        x1="81.508"
        y1="31.679"
        x2="93.19"
        y2="6.047"
      >
        <stop offset=".118" stopColor="#6d7078" stopOpacity="0" />
        <stop offset=".2" stopColor="#6d7078" stopOpacity=".7" />
        <stop offset=".34" stopColor="#35363a" />
        <stop offset=".374" stopColor="#1d1f22" />
        <stop offset=".4" stopColor="#101215" />
        <stop offset=".5" stopColor="#16171a" />
        <stop offset=".56" stopColor="#292a2e" />
        <stop offset=".688" stopColor="#4b4d51" />
        <stop offset=".807" stopColor="#63666b" />
        <stop offset=".915" stopColor="#72757b" />
        <stop offset="1" stopColor="#777a80" />
      </linearGradient>
      <path
        d="M99.5 31.6c.5-.7 1.7-2.7 3.2-4.5 1-1.2 6.4-3.8 7.6-8 .7-2.3-.4-4.6-1.9-5.6-5.1-3.1-13.9-8-26.8-8-8.7 0-12.4 2.9-12.4 2.9h4.4l15.3 6 1.9 8s.2 2.7-.7 5.8c-.6 2.5-.8 4-1.7 6.5.7.3 2.3-.8 4.1-.3 1.6.4 2.6 2.6 3.7 1.3 1.9-2.5 2.5-3 3.3-4.1z"
        fill="url(#xcode-original-T)"
      />
      <linearGradient
        id="xcode-original-U"
        gradientUnits="userSpaceOnUse"
        x1="69.064"
        y1="16.837"
        x2="91.026"
        y2="16.837"
      >
        <stop offset="0" stopColor="#4a4d56" />
        <stop offset="1" stopColor="#29292d" />
      </linearGradient>
      <path
        d="M90.5 25.4C89.7 18 87.9 11 69.1 11.1c1.2-1.2 4.1-2.4 4.1-2.4l-4.1-.3s.6-.5 1.8-.6c11-.9 20.8 1.4 20.1 15.7-.1 2.3-.3 3.3-.5 1.9z"
        fill="url(#xcode-original-U)"
      />
      <linearGradient
        id="xcode-original-V"
        gradientUnits="userSpaceOnUse"
        x1="69.064"
        y1="11.697"
        x2="88.054"
        y2="11.697"
      >
        <stop offset="0" stopColor="#767880" />
        <stop offset=".41" stopColor="#0c0a0b" />
      </linearGradient>
      <path
        d="M69.1 11.1c1.3-.5 3.1-.8 6.5-.6 4.2.2 9.5 1.8 11.7 3.8 1.1 1 1 .2-.2-1.1-3.1-3.6-7.8-4.4-13.9-4.5-.7-.1-3 1.2-4.1 2.4z"
        fill="url(#xcode-original-V)"
      />
      <linearGradient
        id="xcode-original-W"
        gradientUnits="userSpaceOnUse"
        x1="116.332"
        y1="34.756"
        x2="123.707"
        y2="21.982"
      >
        <stop offset="0" stopColor="#858997" />
        <stop offset=".23" stopColor="#244668" />
        <stop offset=".282" stopColor="#1a3249" />
        <stop offset=".4" stopColor="#040506" />
        <stop offset=".464" stopColor="#313236" />
        <stop offset=".546" stopColor="#65656e" />
        <stop offset=".607" stopColor="#868691" />
        <stop offset=".64" stopColor="#92929e" />
      </linearGradient>
      <path
        d="M120.7 20.6l5.5 2.8s-2.1 2.8-3.8 6c-1.8 3.4-3 7.1-3 7.1l-5.3-3.2s1.3-3.6 3.2-7.1c1.5-2.9 3.4-5.6 3.4-5.6z"
        fill="url(#xcode-original-W)"
      />
      <path
        d="M126.2 23.4c.4.2-.9 3.3-2.8 6.9-1.9 3.6-3.7 6.4-4 6.2-.4-.2.9-3.3 2.8-6.9 1.8-3.6 3.6-6.4 4-6.2z"
        fill="#bfc0d0"
      />
    </svg>
  )
}
